export const maxObjects = 750;
